import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Protected } from "@/components/layout/Protected";
import { ArrowRightIcon } from "@/toolbox/constants/icons";
import { VALIDATORS } from "@/toolbox/helpers/validation-rules";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Grid, Container, Button, Autocomplete,Typography, TextField, Divider, InputAdornment, FormControlLabel, Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip, TablePagination, } from '@mui/material';
import { Input } from '@components/common/Input';
import { Props } from "./ResumeByWorker.type";
import { InputRef } from '@/components/common/Input/InputInterfaces';
import './ResumeByWorker_style.css';
import { Link } from 'react-router-dom';
import {  ROUTE_RM_RESUME_QUOTAS } from '@/toolbox/constants/route-map';

interface Column {
   id: 'id' | 'nombre';
   label: string;
   minWidth?: number;
   align?: 'right';
   format?: (value: number) => string;
}

const columns: readonly Column[] = [
   { id: 'id', label: 'Rut', minWidth: 100 },
   { id: 'nombre', label: 'Razón Social', minWidth: 100 }
];

interface Data {
   id: string;
   nombre: string;
}
function createDataContrato(
   id: string,
   nombre: string
): Data {
   return { id, nombre };
}


export const ResumeByWorker: React.FC<Props> = (props: Props): JSX.Element => {
   const inputRefs = useRef<Array<InputRef | null>>([]);
   const [loading, setLoading] = useState(false);
   const [isDisabled, setIsDisabled] = useState<boolean>(false);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);

   const [open, setOpen] = useState(false);
   const handleOpen = () => setOpen(true);
   const handleClose = () => setOpen(false);

   const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
   };

   const [value, setValue] = React.useState<Date | null>(
      new Date('2018-01-01T00:00:00.000Z'),
   );

   const trabajador = [
      { label: 'Goku' },
      { label: 'Cristiano Ronaldo Dos Santos' },
      { label: 'Pedrito Alcachofas' },
      { label: 'Bob Esponja' },
      { label: 'Will Smith Jaden' },
      { label: 'El sambo Cabero' }
   ]
   const estado = [
      { label: 'Generada' },
      { label: 'Pagada' },
      { label: 'Pendiente' }
   ]

   const rules = useMemo(() => ({
      rut_proveedor: [
         VALIDATORS.REQUIRED,
      ],
      numero_contrato: [
         VALIDATORS.REQUIRED,
         VALIDATORS.CODE.ONLY_NUMBER
      ],
      titulo: [
         VALIDATORS.REQUIRED
      ],
      descripcion: [
         VALIDATORS.REQUIRED,
      ]

   }), []);
   const handleInput = (event) => {
      const name = event.target.name;
      const value = event.target.value;
      switch (name) {
         case 'rut_proveedot':
            props.setvalueContrato(prev => ({ ...prev, rut_proveedot: value }));
            break;
         case 'numero_contrato':
            props.setvalueContrato(prev => ({ ...prev, numero_contrato: value }))
            break;
         case 'titulo':
            props.setvalueContrato(prev => ({ ...prev, titulo: value }))
            break;
         case 'descripcion':
            props.setvalueContrato(prev => ({ ...prev, descripcion: value }));
            break;

         default:
            break;
      }
   };

   const handleSubmit = async (event: React.SyntheticEvent) => {
      event.preventDefault();
   }
   const validate = () => {
      const refs = inputRefs.current;
      const valid = refs.reduce((prev, ref) => {
         const isValid = ref && ref.validate(true) || false
         return prev && isValid;
      }, true);
      return valid;
   }
   return (
      <Protected>
         <Container maxWidth='xl'>
            <form style={{ margin: '10px' }}>
               <Typography variant="h6" gutterBottom mb={3} className="tittle">
                  INFORME POR TRABAJADOR
               </Typography>

               <Grid container xs={12} className={`e-mb-lg`} >
                  <Grid container item xs={11} >
                     <Grid item xs={12} sm={5} mb={5} >
                        <Grid item container className='bg-tittle' mb={2} p={1}>
                           <Typography gutterBottom variant="h6" component="div">
                              Informe Mensual
                           </Typography>
                        </Grid>
                        <Grid container  aria-label="mailbox folders" sx={{ justifyContent: 'space-between' }}>
                           <Grid item xs={8} md={6} m={1}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                 <DatePicker
                                    label="Fecha desde"

                                    value={value}
                                    onChange={(newValue) => {
                                       setValue(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                 />
                              </LocalizationProvider>
                           </Grid>
                           <Grid item xs={8} md={6} m={1}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                 <DatePicker
                                    label="Fecha hasta"

                                    value={value}
                                    onChange={(newValue) => {
                                       setValue(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                 />
                              </LocalizationProvider>
                           </Grid>
                           <Grid item xs={8}  m={1}>
                              <Autocomplete
                                 disablePortal
                                 size='small'
                                 id="combo-box-demo"
                                 options={trabajador}
                                 // sx={{ bgcolor: '#F3F3F3'}}
                                 renderInput={(params) => <TextField {...params} label="Trabajador" />}
                              />
                           </Grid>
                           <Grid item xs={2}></Grid>
                           <Grid item xs={8} md={5} m={1}>
                              <Autocomplete
                                 disablePortal
                                 size='small'
                                 id="combo-box-demo"
                                 options={estado}
                                 // sx={{ bgcolor: '#F3F3F3'}}
                                 renderInput={(params) => <TextField {...params} label="Estado" />}
                              />
                           </Grid>
                           <Grid item container
                              xs={12}
                              justifyContent='center'
                              mt={2}
                           >
                              <Grid item>
                                 <Button
                                    type='submit'
                                    variant='contained'
                                    // onClick={handleSubmit}
                                    disabled={loading}
                                    disableElevation
                                    component={Link}
                                    to={ROUTE_RM_RESUME_QUOTAS}
                                    className='btn_save'
                                 >
                                    Consultar
                                 </Button>
                              </Grid>
                           </Grid>
                        </Grid>
                     </Grid>                    
                  </Grid>
               </Grid>
            </form>
         </Container>
      </Protected>
   );
}